export function blurText(targetSelectors, observerOptions) {
  const targets = document.querySelectorAll(targetSelectors);
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const target = entry.target;
        const animatedText = target.querySelector(".v_blur_text");
        animatedText.classList.add("v_unblur_text");
      }
    });
  }, observerOptions);
  targets.forEach((target) => {
    observer.observe(target);
  });
}
